import React, { useEffect } from "react";

const SocialIcon = ({ type }) => {
  if (type === "whatsapp") {
    return (
      <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M12 2a10 10 0 0 0-8.66 15l-1.22 4.46 4.57-1.2A10 10 0 1 0 12 2zm0 18a8 8 0 0 1-4.1-1.13l-.29-.17-2.71.71.72-2.63-.19-.3A8 8 0 1 1 12 20zm4.38-5.92c-.24-.12-1.42-.7-1.64-.78-.22-.08-.38-.12-.54.12-.16.24-.62.78-.76.94-.14.16-.28.18-.52.06-.24-.12-1-.37-1.9-1.19-.7-.62-1.17-1.38-1.31-1.62-.14-.24-.01-.37.1-.49.1-.1.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.54-1.3-.74-1.78-.2-.48-.4-.4-.54-.4h-.46c-.16 0-.42.06-.64.3-.22.24-.84.82-.84 2 0 1.18.86 2.32.98 2.48.12.16 1.68 2.56 4.08 3.59.57.24 1.02.39 1.37.49.58.18 1.1.15 1.52.09.46-.07 1.42-.58 1.62-1.14.2-.56.2-1.04.14-1.14-.06-.1-.22-.16-.46-.28z"
        />
      </svg>
    );
  }
  if (type === "facebook") {
    return (
      <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M24 12a12 12 0 1 0-13.88 11.86v-8.39H7.08V12h3.04V9.36c0-3 1.79-4.66 4.53-4.66 1.31 0 2.68.23 2.68.23v2.95h-1.51c-1.49 0-1.95.92-1.95 1.86V12h3.32l-.53 3.47h-2.79v8.39A12 12 0 0 0 24 12z"
        />
      </svg>
    );
  }
  if (type === "instagram") {
    return (
      <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2zm0 1.8A3.95 3.95 0 0 0 3.8 7.75v8.5a3.95 3.95 0 0 0 3.95 3.95h8.5a3.95 3.95 0 0 0 3.95-3.95v-8.5a3.95 3.95 0 0 0-3.95-3.95h-8.5zm8.94 1.35a1.21 1.21 0 1 1 0 2.42 1.21 1.21 0 0 1 0-2.42zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 1.8a3.2 3.2 0 1 0 0 6.4 3.2 3.2 0 0 0 0-6.4z"
        />
      </svg>
    );
  }
  if (type === "linkedin") {
    return (
      <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9h4v12H3V9zm7 0h3.8v1.64h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.09V21h-4v-5.52c0-1.32-.02-3.01-1.83-3.01-1.83 0-2.11 1.43-2.11 2.92V21h-4V9z"
        />
      </svg>
    );
  }
  if (type === "github") {
    return (
      <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M12 .5C5.65.5.5 5.66.5 12.02c0 5.09 3.29 9.41 7.86 10.94.58.1.79-.25.79-.56l-.02-2.15c-3.2.7-3.88-1.54-3.88-1.54-.53-1.34-1.28-1.7-1.28-1.7-1.04-.72.08-.71.08-.71 1.15.08 1.75 1.18 1.75 1.18 1.02 1.74 2.67 1.24 3.32.95.1-.74.4-1.24.73-1.53-2.56-.29-5.25-1.28-5.25-5.69 0-1.26.45-2.29 1.18-3.1-.12-.29-.51-1.46.11-3.04 0 0 .97-.31 3.17 1.18a10.96 10.96 0 0 1 5.77 0c2.2-1.49 3.17-1.18 3.17-1.18.62 1.58.23 2.75.11 3.04.74.81 1.18 1.84 1.18 3.1 0 4.42-2.69 5.39-5.26 5.67.41.35.78 1.05.78 2.12l-.01 3.14c0 .31.21.67.8.56A11.52 11.52 0 0 0 23.5 12C23.5 5.66 18.35.5 12 .5z"
        />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42 9.3-9.29H14V3zM5 5h6v2H7v10h10v-4h2v6H5V5z"
      />
    </svg>
  );
};

const About = () => {
  useEffect(() => {
    document.body.classList.add("gf-about-no-main-wrap-pad");
    return () => document.body.classList.remove("gf-about-no-main-wrap-pad");
  }, []);

  return (
    <section className="gf-page gf-about-page">
      <div className="gf-container gf-about-page__container">
        <article className="gf-about-card">
          <div className="gf-about-grid">
            <aside className="gf-about-brand">
              <div className="gf-about-avatar-wrap">
                <img
                  src="/Adnan.png"
                  alt="Adnan Shafique"
                  className="gf-about-avatar"
                />
              </div>
              <h2 className="gf-about-brand__name">Adnan Shafique</h2>
              <p className="gf-about-brand__role">Full Stack Developer</p>
              <p className="gf-about-brand__tagline">
                Building fast, scalable and user-focused web experiences.
              </p>

              <div className="gf-about-socials">
                <div className="gf-about-socials__grid">
                  <a
                    href="https://www.linkedin.com/in/muhammad-adnan-shafique/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="gf-about-socials__link is-linkedin"
                    aria-label="LinkedIn"
                    title="LinkedIn"
                  >
                    <SocialIcon type="linkedin" />
                  </a>
                  <a
                    href="https://github.com/adnan2188"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="gf-about-socials__link is-github"
                    aria-label="GitHub"
                    title="GitHub"
                  >
                    <SocialIcon type="github" />
                  </a>
                  <a
                    href="https://adnwebs.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="gf-about-socials__link is-portfolio"
                    aria-label="Portfolio"
                    title="Portfolio"
                  >
                    <SocialIcon type="portfolio" />
                  </a>
                  <a
                    href="https://wa.me/923236882188"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="gf-about-socials__link is-whatsapp"
                    aria-label="WhatsApp"
                    title="WhatsApp"
                  >
                    <SocialIcon type="whatsapp" />
                  </a>
                </div>
              </div>
            </aside>

            <div className="gf-about-content">
              <h1 className="gf-about-content__title">
                About <span>ADN WEBS</span>
              </h1>
              <p className="gf-about-card__text">
                Hi, I&apos;m <span className="gf-about-card__name">Adnan Shafique</span> - a full stack developer
                focused on building modern, fast, and user-friendly web applications.
              </p>
              <p className="gf-about-card__text">
                This platform is designed to help users discover GitHub developers and repositories through a clean
                interface, powerful filters, and practical search workflows.
              </p>
              <p className="gf-about-card__highlight">🚀 Built for developers &amp; recruiters</p>
              <p className="gf-about-card__text gf-about-card__text--last">
                The goal is to simplify developer discovery and make technical exploration more efficient and
                accessible.
              </p>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
};

export default About;
